import React from "react";
var __jsx = React.createElement;
import isNil from 'lodash/isNil';
import { useCallback, useEffect, useState } from 'react';
import useGetBlockData from 'components/common/RichTextEditor/hooks/useGetBlockData';
import { SlideshowEmbedDialog } from 'components/content/SlideshowEmbedDialog';

var SlideshowEmbed = function SlideshowEmbed(_ref) {
  var editorState = _ref.editorState,
      blockKey = _ref.blockKey,
      entityKey = _ref.entityKey,
      removeBlock = _ref.removeBlock,
      updateBlockData = _ref.updateBlockData,
      updateEntity = _ref.updateEntity;

  var _useState = useState(),
      slideshowEmbedData = _useState[0],
      setSlideshowEmbedData = _useState[1];

  var _useState2 = useState(false),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useGetBlockData = useGetBlockData(editorState, blockKey, entityKey),
      blockData = _useGetBlockData.blockData,
      entityData = _useGetBlockData.entityData;

  useEffect(function () {
    setIsOpen(blockData.openModal);
    setSlideshowEmbedData(entityData);
  }, [blockData.openModal, entityData]);
  var handleModalClose = useCallback(function () {
    if (slideshowEmbedData === undefined || isNil(slideshowEmbedData.contentId)) {
      removeBlock(blockKey);
      return;
    }

    updateBlockData(blockKey, {
      openModal: false
    });
  }, [slideshowEmbedData, updateBlockData, blockKey, removeBlock]);
  var handleConfirm = useCallback(function (currentSlideshowEmbedData) {
    // in case we remove selected slideshow in dialog and confirm
    if (currentSlideshowEmbedData.contentId === '') {
      removeBlock(blockKey);
      return;
    }

    updateEntity(entityKey, currentSlideshowEmbedData);
    updateBlockData(blockKey, {
      openModal: false
    });
  }, [blockKey, entityKey, removeBlock, updateBlockData, updateEntity]);
  return __jsx(SlideshowEmbedDialog, {
    open: isOpen,
    initialSlideshowEmbedData: slideshowEmbedData,
    onClose: handleModalClose,
    onConfirm: handleConfirm
  });
};

export default SlideshowEmbed;